<template>
  <div style="position: absolute; width: 100%; height: 100vh;">
    <img @mouseover="tiltUp" @mouseleave="stopTilt" class="arrow-circle arrow-up" src="../assets/images/arrow.svg">
    <img @mouseover="tiltDown" @mouseleave="stopTilt" class="arrow-circle arrow-down" src="../assets/images/arrow.svg">
  </div>
  <div style="display: flex">
    <img @mouseover="panLeft" @mouseleave="stopPan" class="arrow-circle arrow-left" src="../assets/images/arrow.svg">
    <img @mouseover="panRight" @mouseleave="stopPan" class="arrow-circle arrow-right" src="../assets/images/arrow.svg">
  </div>
  <div class="camera-background"></div>
  <div id="container"></div>
</template>

<script>
import * as THREE from 'three';
class Cube extends THREE.Mesh {
  constructor() {
    super()
    this.geometry = new THREE.SphereGeometry(0.4, 32, 16);
    this.material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
    this.cubeSize = 0
    this.cubeScale = 4
    this.cubeActive = false
    this.data = {}
  }
  render() {
    this.rotation.x = this.rotation.y += 0.01
  }
  onResize(width, height, aspect) {
    this.cubeSize = (height * aspect) / 5 * this.cubeScale
    this.scale.setScalar(this.cubeSize * (this.cubeActive ? 1.5 : 1))
  }
  onPointerOver(e) {
    if (this.parent && this.parent.children) {
      let sprite = this.parent.children[0]
      sprite.scale.set(1.35, 1.35, 1)
      if (this.data && this.data.type == "door") {
        doorHover(this.data)
        sprite.material.map = new THREE.TextureLoader().load('./images/ship-arrow-active.png');
      } else {
        sprite.material.map = new THREE.TextureLoader().load('./images/circle-active.png');
      }
    }
  }
  onPointerOut(e) {
    if (this.parent && this.parent.children) {
      let sprite = this.parent.children[0]
      sprite.scale.set(1, 1, 1)
      sprite.material.color.set('white')
      if (this.data && this.data.type == "door") {
        doorHover({ zone: null })
        sprite.material.map = new THREE.TextureLoader().load('./images/ship-arrow.png');
      } else {
        sprite.material.map = new THREE.TextureLoader().load('./images/circle.png');
      }
    }
  }
  onClick(e) {
    this.cubeActive = !this.cubeActive
    this.scale.setScalar(this.cubeSize * (this.cubeActive ? 1.5 : 1))
  }
}
function doorHover() {}
import { onUpdated } from 'vue';
export default {
  name: "CameraView",
  components: {},
  props: {},
  data() {
    return {
      camera: null,
      switchRoom: null,
      pan: 0,
      tilt: 0,
    }
  },
  mounted() {
    this.setUp3D()
    doorHover = this.doorHover
  },
  computed: {
    shipAreas() {
      return this.$store.getters.getShipAreas
    },
    shipArea() {
      return this.$store.getters.getShipArea
    }
  },
  methods: {
    panLeft() { this.pan = -0.2 },
    panRight() { this.pan = 0.2 },
    stopPan() { this.pan = 0 },
    tiltUp() { this.tilt = 0.2 },
    tiltDown() { this.tilt = -0.2 },
    stopTilt() { this.tilt = 0 },
    doorHover(data) {
      this.$store.commit("setShipHover", data)
    },
    nextItem() {
      this.pan = .1
    },
    previousItem() {
      this.$store.commit("setShipArea", (this.shipAreas.length + this.shipArea - 1) % this.shipAreas.length)
      this.switchRoom()
    },
    setUp3D() {
      let self = this
      let width = 0
      let height = 0
      let intersects = []
      let hovered = {}
      this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1100);
      this.camera.target = new THREE.Vector3(0, 0, 0);
      this.camera.position.z = 1;
      const scene = new THREE.Scene();
      const raycaster = new THREE.Raycaster()
      const mouse = new THREE.Vector2()
      const geometryS = new THREE.SphereGeometry(500, 60, 40);
      geometryS.scale(- 1, 1, 1);
      const materialS = new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(this.shipAreas[this.shipArea].map)
      });
      var isUserInteracting
      var onPointerDownPointerX, onPointerDownPointerY, onPointerDownLon, onPointerDownLat
      const geometry = new THREE.BoxGeometry(2, 2, 2);
      const material = new THREE.MeshNormalMaterial();
      var hotSpots = this.shipAreas[this.shipArea].objs
      var objs = []
      addHotSpots(hotSpots)
      function addHotSpots(hotSpots) {
        for (var h in hotSpots) {
          let axis = new THREE.Mesh(geometry, material);
          let mesh = new Cube();
          mesh.data = hotSpots[h]
          mesh.onClick = function () {
            if (this.data.type == "door") {
              self.$store.commit("setShipArea", this.data.zone)
              newRot = this.data.rot || 0
              self.switchRoom()
            } else {
              self.$store.commit("setSelectedItemID", this.data.id)
              self.$store.commit("setShowPopup", !this.showPopup360)
            }
          }
          axis.rotation.y = (hotSpots[h].r) / 180 * Math.PI
          mesh.position.x = 0
          mesh.position.y = hotSpots[h].v
          mesh.position.z = hotSpots[h].z
          mesh.visible = false
          let map
          let mapRot = 0
          if (hotSpots[h].type == "door") {
            if (hotSpots[h].sRot) {
              mapRot = hotSpots[h].sRot * Math.PI / 180
            }
            map = new THREE.TextureLoader().load('./images/ship-arrow.png');
          } else {
            map = new THREE.TextureLoader().load('./images/circle.png');
          }
          const materialX = new THREE.SpriteMaterial({ map: map, rotation: mapRot });
          const sprite = new THREE.Sprite(materialX);
          sprite.position.x = 0
          sprite.position.y = hotSpots[h].v
          sprite.position.z = hotSpots[h].z
          axis.add(sprite)
          axis.add(mesh);
          scene.add(axis);
          objs.push({ axis: axis, mesh: mesh })
        }
      }
      const meshS = new THREE.Mesh(geometryS, materialS);
      scene.add(meshS);
      const renderer = new THREE.WebGLRenderer();
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setAnimationLoop(animation);
      document.addEventListener('mousedown', onDocumentMouseDown, false);
      document.addEventListener('mousemove', onDocumentMouseMove, false);
      document.addEventListener('mouseup', onDocumentMouseUp, false);
      document.getElementById("duyfken360").appendChild(renderer.domElement);
      function onDocumentMouseDown(event) {
        isUserInteracting = true;
        onPointerDownPointerX = event.clientX;
        onPointerDownPointerY = event.clientY;
        onPointerDownLon = lon;
        onPointerDownLat = lat;
      }
      function onDocumentMouseUp(event) {
        isUserInteracting = false;
      }
      this.switchRoom = function nextRoom() {
        for (var obj in objs) {
          objs[obj].mesh.geometry.dispose();
          objs[obj].axis.remove(objs[obj].mesh);
          objs[obj].axis.geometry.dispose();
          scene.remove(objs[obj].axis);
        }
        hotSpots = this.shipAreas[this.shipArea].objs
        objs = []
        addHotSpots(hotSpots)
        materialS.map.image.src = this.shipAreas[this.shipArea].map
        materialS.map.needsUpdate = true;
      }
      function onDocumentMouseMove(event) {
        if (isUserInteracting === true) {
          lon = (onPointerDownPointerX - event.clientX) * 0.1 + onPointerDownLon;
          lat = (event.clientY - onPointerDownPointerY) * 0.1 + onPointerDownLat;
        }
        mouse.set((event.clientX / width) * 2 - 1, -(event.clientY / height) * 2 + 1)
        raycaster.setFromCamera(mouse, self.camera)
        intersects = raycaster.intersectObjects(scene.children, true)
        Object.keys(hovered).forEach((key) => {
          const hit = intersects.find((hit) => hit.object.uuid === key)
          if (hit === undefined) {
            const hoveredItem = hovered[key]
            if (hoveredItem.object.onPointerOver) hoveredItem.object.onPointerOut(hoveredItem)
            delete hovered[key]
          }
        })
        intersects.forEach((hit) => {
          if (!hovered[hit.object.uuid]) {
            hovered[hit.object.uuid] = hit
            if (hit.object.onPointerOver) hit.object.onPointerOver(hit)
          }
          if (hit.object.onPointerMove) hit.object.onPointerMove(hit)
        })
      }
      window.addEventListener('click', (e) => {
        intersects.forEach((hit) => {
          if (hit.object.onClick) hit.object.onClick(hit)
        })
      })
      let lat, lon, phi, theta, newRot
      function animation(time) {
        lat = lat || 0
        lon = lon || 0
        phi = phi || 0
        theta = theta || 0
        if (isUserInteracting === false) {
        }
        if (self.pan) {
          lon += self.pan
        }
        if (self.tilt) {
          lat += self.tilt
        }
        if (newRot && (newRot)) {
          lon = newRot
          newRot = null
        }
        lat = Math.max(- 85, Math.min(85, lat));
        phi = (90 - lat) / 180 * Math.PI
        theta = (lon) / 180 * Math.PI
        self.camera.target.x = 500 * Math.sin(phi) * Math.cos(theta);
        self.camera.target.y = 500 * Math.cos(phi);
        self.camera.target.z = 500 * Math.sin(phi) * Math.sin(theta);
        self.camera.lookAt(self.camera.target);
        renderer.render(scene, self.camera);
      }
      function resize() {
        width = window.innerWidth
        height = window.innerHeight
        self.camera.aspect = width / height
        const target = new THREE.Vector3(0, 0, 0)
        const distance = self.camera.position.distanceTo(target)
        const fov = (self.camera.fov * Math.PI) / 180
        const viewportHeight = 2 * Math.tan(fov / 2) * distance
        const viewportWidth = viewportHeight * (width / height)
        self.camera.updateProjectionMatrix()
        renderer.setSize(width, height)
        scene.traverse((obj) => {
          if (obj.onResize) obj.onResize(viewportWidth, viewportHeight, self.camera.aspect)
        })
      }
      window.addEventListener('resize', resize)
      resize()
    },
    animate(renderer, scene, time) {
      renderer.render(scene, self.camera);
    },
  },
  watch: {
    shipArea(val) {
      this.switchRoom()
    }
  }
};
</script>

<style scoped>
.item-circle {
  width: 1em;
  height: 1em;
  border-radius: 100%;
  border: 0.5em solid var(--white);
  background-color: var(--indigo);
  filter: drop-shadow(0 0 0.25em var(--indigo)) drop-shadow(0 0 0.25em var(--indigo));
  cursor: pointer;
  transition: 0.1s;
}
.area-box {
  width: 6em;
  filter: brightness(100%) drop-shadow(0 0 0.25em var(--indigo)) drop-shadow(0 0 0.25em var(--indigo));
  cursor: pointer;
  transition: 0.25s;
}
.area-box:hover {
  filter: brightness(200%) drop-shadow(0 0 0.25em var(--indigo)) drop-shadow(0 0 0.25em var(--indigo));
}
.arrow-circle {
  width: 1.5em;
  height: 1.5em;
  padding: 5px;
  margin: 0 3.5em;
  border-radius: 100%;
  background-color: var(--blue);
  filter: drop-shadow(0 0 0.25em var(--indigo)) drop-shadow(0 0 0.25em var(--indigo));
  position: absolute;
  top: calc(50% - 1em);
  cursor: pointer;
  transition: 0.1s;
}
.arrow-circle:hover {
  background-color: var(--white);
}
.arrow-left {
  left: -1.5em;
  transform: rotate(180deg);
}
.arrow-up {
  top: 1.5em;
  left: 0;
  right: 0;
  margin: auto;
  transform: rotate(-90deg);
}
.arrow-down {
  bottom: 1.5em;
  left: 0;
  right: 0;
  top: unset;
  margin: auto;
  transform: rotate(90deg);
}
.arrow-right {
  right: -1.5em;
}
</style>